import { Injectable } from "@angular/core";

import { ApiResourceService } from "../api-resource.service";
import { ApiSessionService } from "../../api-session.service";

import { ApiAction, ApiAddAction, ApiDeleteAction } from "../../api-actions";
import { ApiStateStoreService } from "../../api-state-store.service";
import { extractData, OnsipApiResponse } from "../../apiResponse/response-body-new";
import { getApiActionName } from "../../onsip-api-action-new";

import { sessionId } from "../../apiParams/session-id";
import { organizationId } from "../../apiParams/organization-id";
import { arrayToRecord } from "../../util/arrayToRecord";

import {
  UserAlias,
  ApiUserAlias,
  apiUserAliasToUserAlias as clean,
  AddUserAliasParams
} from "./user-alias";
import { onsipApiArrayToArray } from "../../apiResponse/xml-json";
import { ApiPromiseState, ApiPromiseStateService } from "../../api-promise-state.service";
import { ParameterValue } from "../../util/api-action-description";
export { UserAlias };

const debug = false;

@Injectable({ providedIn: "root" })
export class UserAliasService extends ApiResourceService<UserAlias> {
  constructor(
    session: ApiSessionService,
    store: ApiStateStoreService,
    promiseState: ApiPromiseStateService
  ) {
    super(session, store, promiseState, "UserAlias", "aliasUsername");
    debug && this.state.subscribe(state => console.warn("UserAliasService", state));
  }

  userAliasBrowse(params: Record<string, ParameterValue> = {}): ApiPromiseState<UserAlias> {
    this.dispatcher.next({
      parameters: {
        Action: ApiAction.UserAliasBrowse,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        Limit: 10000,
        ...params
      }
    });
    return this.promiseState.toPromise(ApiAction.UserAliasBrowse);
  }

  userAliasAdd(params: AddUserAliasParams): ApiPromiseState<UserAlias> {
    this.dispatcher.next({
      parameters: {
        Action: ApiAddAction.UserAliasAdd,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        ...params
      }
    });
    return this.promiseState.toPromise(ApiAddAction.UserAliasAdd);
  }

  userAliasDelete(AliasUsername: string): ApiPromiseState<UserAlias> {
    this.dispatcher.next({
      parameters: {
        Action: ApiDeleteAction.UserAliasDelete,
        SessionId: this.store.state.pipe(sessionId()),
        OrganizationId: this.store.state.pipe(organizationId()),
        AliasUsername
      }
    });
    return this.promiseState.toPromise(ApiDeleteAction.UserAliasDelete);
  }

  reducer(response: OnsipApiResponse): void {
    const action = getApiActionName(response);
    switch (action) {
      case ApiAction.UserAliasBrowse:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            extractData<Array<ApiUserAlias>>(response, action, "UserAlias", "UserAliases").map(
              clean
            ),
            this.indexKeyName
          ),
          action,
          true
        );
        break;
      case ApiAddAction.UserAliasAdd:
        this.store.mergeStateUpdate(
          this.resourceName,
          arrayToRecord(
            [clean(extractData<ApiUserAlias>(response, action, "UserAlias"))],
            this.indexKeyName
          ),
          action
        );
        break;
      case ApiDeleteAction.UserAliasDelete:
        if (!response.Context.Request.Parameters) break;
        // eslint-disable-next-line no-case-declarations
        const deleted = onsipApiArrayToArray(response.Context.Request.Parameters, "Parameter").find(
          param => param.Name === "AliasUsername"
        )?.Value;
        deleted && this.store.mergeStateUpdate(this.resourceName, { [deleted]: undefined }, action);
        break;
    }
  }
}
